import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import cookie from '../assets/utils/cookie'

Vue.use(Router)

const router = new Router({
  mode:'history',
  base: 'course',
  routes: [
    {
      path: '/',
      name: 'login',
      redirect: 'login',
    },
    {
      path: '/login',
      name: 'login',
      component: require('../pages/login').default,
    },
    {
      path: '/index',
      name: 'index',
      component: require('../pages/index').default,
      meta: {
        requiresAuth:true,
      }
    }
  ]
})

router.afterEach(() => {
  // 友盟统计
  document.body.scrollTop = 0
  document.documentElement.scrollTop = 0
  setTimeout(()=>{
    (function() {
     var vds = document.createElement('script')
      vds.type = 'text/javascript'
      vds.async = true
      vds.src = (document.location.protocol === 'https:' ? 'https://' : 'http://') +
        's13.cnzz.com/z_stat.php?id=1274369091&web_id=1274369091'
      var s = document.getElementsByTagName('script')[0]
      s.parentNode.insertBefore(vds, s)
    })();
  },0);
})


// 路由鉴权
router.beforeEach((to, from, next) => {
  //判断是否为微信浏览器 静默授权获取openId
  let ua = window.navigator.userAgent.toLowerCase();
  let token = localStorage.getItem("bfe_t");
  let openId = localStorage.getItem("bfe_o");
  let mobile = localStorage.getItem("bfe_m");
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if(token){
      next();
    }else if(openId){
      next();
    }else if(mobile){
      next();
    }else{
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    }
  } else {
    next();
  }
  // next();
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js